import { on } from 'delegated-events'

const SELECTORS = Selectors({
  faq: 'faqs-item__question'
})

const $faqs = document.querySelectorAll(SELECTORS.asClass('faq'))

const fn = {
  init: () => {
    on('click', SELECTORS.asClass('faq'), fn.toggle)
    on('keydown', SELECTORS.asClass('faq'), fn.toggle)
  },

  toggle: (e) => {
    if (e.target.closest(SELECTORS.asClass('faq'))) {
      const expanded = e.target.getAttribute('aria-expanded') === 'true'
      e.target.setAttribute('aria-expanded', expanded ? 'false' : 'true')
      $(e.target).closest('.faqs-item').find('.faqs-item__answer').slideToggle()
    }
  }
}

export default {
  can: () => $faqs.length,
  run: fn.init
}
